import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './NotFound.scss';

export const NotFound = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="not-found">
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <p>The page you are looking for doesn't exist or has been moved.</p>
      <Link to={isAuthenticated ? '/' : '/signin'} className="back-link">
        {isAuthenticated ? 'Back to Home' : 'Go to Sign In'}
      </Link>
    </div>
  );
};
